const GENERIC_PROVIDER_ERROR = 'Provider rejected the message';
const AUTH_PROVIDER_ERROR = 'Authentication error';
const RATE_LIMIT_PROVIDER_ERROR = 'Rate limited by provider';
const INVALID_DESTINATION_PROVIDER_ERROR = 'Invalid recipient or sender';
const BLOCKED_PROVIDER_ERROR = 'Recipient blocked messages';

const CREDENTIAL_ASSIGNMENT_PATTERN = /\b(?:api[_-]?key|access[_-]?token|refresh[_-]?token|id[_-]?token|auth[_-]?token|token|secret|password|client[_-]?secret|authorization)\b\s*[:=]\s*(?:Bearer\s+)?["']?[^"'\s,;)}\]]+["']?/gi;
const BEARER_PATTERN = /\bBearer\s+["']?[^"'\s,;)}\]]+["']?/gi;
const LONG_OPAQUE_TOKEN_PATTERN = /\b(?=[A-Za-z0-9_-]{24,}\b)(?=[A-Za-z0-9_-]*[A-Za-z])(?=[A-Za-z0-9_-]*\d)[A-Za-z0-9_-]+\b/g;

function classifyProviderError(message) {
  const lower = message.toLowerCase();

  if (/\b(unauthorized|forbidden|authentication|authorization|auth|credential|api[_ -]?key|token|secret|password|bearer|401|403)\b/.test(lower)) {
    return AUTH_PROVIDER_ERROR;
  }

  if (/\b(rate limit|rate limited|throttle|throttled|too many requests|429)\b/.test(lower)) {
    return RATE_LIMIT_PROVIDER_ERROR;
  }

  if (/\b(invalid|unverified|malformed)\b/.test(lower) && /\b(phone|number|recipient|sender|from|to|destination)\b/.test(lower)) {
    return INVALID_DESTINATION_PROVIDER_ERROR;
  }

  if (/\b(opted out|opt-out|unsubscribe|unsubscribed|blocked|stop)\b/.test(lower)) {
    return BLOCKED_PROVIDER_ERROR;
  }

  return GENERIC_PROVIDER_ERROR;
}

function redactSensitiveProviderText(message) {
  return message
    // eslint-disable-next-line no-control-regex
    .replace(/[\u0000-\u001F\u007F]/g, ' ')
    .replace(/<[^>]*>/g, '')
    .replace(CREDENTIAL_ASSIGNMENT_PATTERN, '[credential redacted]')
    .replace(BEARER_PATTERN, '[credential redacted]')
    .replace(LONG_OPAQUE_TOKEN_PATTERN, '[credential redacted]')
    .replace(/https?:\/\/\S+/gi, '[link removed]')
    .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[email removed]')
    .replace(/\+?\d[\d\s().-]{7,}\d/g, '[phone removed]')
    .replace(/\s+/g, ' ')
    .trim();
}

export function sanitizeProviderError(errorMessage) {
  if (!errorMessage || typeof errorMessage !== 'string') return '';

  const sanitized = redactSensitiveProviderText(errorMessage);

  if (!sanitized) return GENERIC_PROVIDER_ERROR;

  const label = classifyProviderError(errorMessage);
  const redactedSensitiveValue = sanitized.includes('[credential redacted]');
  const looksLikeProviderPayload = /[{}[\]"']/.test(errorMessage) || /\b(error|message|code|details?)\b\s*[:=]/i.test(errorMessage);
  const tooLongForUi = sanitized.length > 120;

  if (label !== GENERIC_PROVIDER_ERROR || redactedSensitiveValue || looksLikeProviderPayload || tooLongForUi) {
    return label;
  }

  return sanitized.slice(0, 120);
}

export const providerErrorSanitizerInternals = {
  classifyProviderError,
  redactSensitiveProviderText,
};
